import React from 'react';
import { FadeIn, Section, Button } from './ui';
import { Check, Shield, Download, BookOpen, ClipboardCheck, CalendarDays } from 'lucide-react';
export function HeroSection() {
  return <div className="relative pt-10" data-id="element-166">
      {/* Urgency Bar */}
      <div className="fixed top-0 left-0 right-0 bg-brand-green text-white text-center py-2.5 px-4 z-50 font-bold text-xs md:text-base shadow-md" data-id="element-167">
        ⚡DOCENTE DE MATEMÁTICA DEJÁ DE PERDER TIEMPO
      </div>

      <Section variant="dark" className="!pt-2 md:!pt-16 !pb-6 md:!pb-10" data-id="element-168">
        <FadeIn data-id="element-169">
          <h1 className="text-[22px] md:text-5xl font-black text-gray-900 leading-[1.15] text-center mb-3 md:mb-5" data-id="element-170">
            MegaPack Matemática Lista
          </h1>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-171">
          <p className="text-sm md:text-xl text-gray-600 text-center mb-4 md:mb-8 max-w-[600px] mx-auto leading-relaxed" data-id="element-172">
            Este sistema te da las clases y las pruebas listas para usar. Deja
            de empezar desde cero cada semana.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-173">
          {/* Product Image */}
          <div className="relative w-full max-w-[180px] md:max-w-[420px] mx-auto mb-4 md:mb-8" data-id="element-174">
            <img src="https://cdn.magicpatterns.com/uploads/mAckYZXMs86ELLFmRv3W6f/Emprendedor_Te_damos_una_solucion._(1080_x_1080_px)_(Post_de_Instagram_(45)).png" alt="Mega Kit Matemática 360 — Incluye ebook principal, 3 bonus exclusivos y materiales para un año" className="w-full h-auto drop-shadow-[0_20px_40px_rgba(5,150,105,0.15)]" loading="eager" decoding="async" data-id="element-175" />
          </div>

          {/* Feature Badges */}
          <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-4 md:mb-8" data-id="element-176">
            <div className="flex items-center gap-2 bg-brand-green/10 border border-brand-green/20 rounded-full px-4 py-2 md:px-5 md:py-2.5" data-id="element-177">
              <BookOpen size={18} className="text-brand-green shrink-0" data-id="element-178" />
              <span className="text-brand-green font-semibold text-sm md:text-base" data-id="element-179">
                Clases
              </span>
            </div>
            <div className="flex items-center gap-2 bg-brand-green/10 border border-brand-green/20 rounded-full px-4 py-2 md:px-5 md:py-2.5" data-id="element-180">
              <ClipboardCheck size={18} className="text-brand-green shrink-0" data-id="element-181" />
              <span className="text-brand-green font-semibold text-sm md:text-base" data-id="element-182">
                Pruebas
              </span>
            </div>
            <div className="flex items-center gap-2 bg-brand-green/10 border border-brand-green/20 rounded-full px-4 py-2 md:px-5 md:py-2.5" data-id="element-183">
              <CalendarDays size={18} className="text-brand-green shrink-0" data-id="element-184" />
              <span className="text-brand-green font-semibold text-sm md:text-base" data-id="element-185">
                Planificaciones
              </span>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-186">
          <Button href="#pricing" variant="primary" className="text-base md:text-xl mb-3 md:mb-5" data-id="element-187">
            <span data-id="element-188">Sí, QUIERO EL SISTEMA AHORA →</span>
          </Button>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs md:text-sm text-gray-500" data-id="element-189">
            <div className="flex items-center gap-1" data-id="element-190">
              <Check size={14} className="text-green-600 shrink-0" data-id="element-191" />
              <span data-id="element-192">+847 docentes</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-193">
              <Download size={14} className="text-brand-blue shrink-0" data-id="element-194" />
              <span data-id="element-195">PDF al instante</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-196">
              <Shield size={14} className="text-brand-gold shrink-0" data-id="element-197" />
              <span data-id="element-198">Garantía 7 días</span>
            </div>
          </div>
        </FadeIn>
      </Section>
    </div>;
}